import { Box, Grid, GridItem, Skeleton, Stack } from "@chakra-ui/react";
import React from "react";

export const EnvironmentalVariablesLoadingSkeleton: React.FC = () => (
  <Box bg="#f4f4f5" borderRadius={8} p={6}>
    <Box bg="#ffffff" borderRadius={8} p={4}>
      <Stack spacing={4}>
        <Skeleton
          height="20px"
          width="80px"
          borderRadius={4}
          startColor="#e8edf2"
          endColor="#f5f7fa"
        />
        <Skeleton
          height="32px"
          width="140px"
          borderRadius={8}
          startColor="#e8edf2"
          endColor="#f5f7fa"
        />
        <Grid templateColumns="repeat(12, 1fr)" gap={4}>
          <GridItem colSpan={4}>
            <Skeleton
              height="40px"
              borderRadius={8}
              startColor="#e8edf2"
              endColor="#f5f7fa"
            />
          </GridItem>
          <GridItem colSpan={4}>
            <Skeleton
              height="40px"
              borderRadius={8}
              startColor="#e8edf2"
              endColor="#f5f7fa"
            />
          </GridItem>
          <GridItem colSpan={4}>
            <Skeleton
              height="40px"
              borderRadius={8}
              startColor="#e8edf2"
              endColor="#f5f7fa"
            />
          </GridItem>
        </Grid>
      </Stack>
    </Box>
  </Box>
);
